<template>
	<Modal title="Generate Access Code">
		<div>
			<Alert />
			<div class="modal-body">
				<form id="accessCodeForm" @submit.prevent="handleSubmit">
					<!-- <div class="logo-container">
						<div class="logo-preview">
							<img
								v-if="form.logoPreview"
								:src="form.logoPreview"
								alt="Association Logo"
								class="logo-image"
							/>
							<i v-else class="fas fa-camera"></i>
						</div>
						<input
							type="file"
							id="logoUpload"
							accept="image/png, image/jpeg, image/jpg"
							@change="handleLogoUpload"
							class="d-none"
						/>
						<label for="logoUpload" class="btn btn-sm btn-link mt-2">
							{{ form.logoPreview ? "Change Logo" : "Upload Logo" }}
						</label>
					</div> -->

					<div class="form-group">
						<label for="proposed_name">NAME OF ASSOCIATION</label>
						<input
							v-model="form.proposed_name"
							type="text"
							class="form-control"
							id="proposed_name"
							placeholder="Enter association name"
							required
						/>
					</div>

					<div class="form-group">
						<label for="acronym">ACRONYM</label>
						<input
							v-model="form.acronym"
							type="text"
							class="form-control"
							id="acronym"
							placeholder="Enter acronym"
							required
						/>
					</div>

					<div class="form-group">
						<label for="motto">SLOGAN</label>
						<input
							v-model="form.motto"
							type="text"
							class="form-control"
							id="motto"
							placeholder="Enter slogan"
						/>
					</div>

					<div class="form-group">
						<label for="protem_chairman">PROTEM CHAIRMAN</label>
						<input
							v-model="form.protem_chairman"
							type="text"
							class="form-control"
							id="protem_chairman"
							placeholder="Enter protem chairman name"
							required
						/>
					</div>

					<div class="form-group">
						<label for="protem_secretarty">PROTEM SECRETARY</label>
						<input
							v-model="form.protem_secretarty"
							type="text"
							class="form-control"
							id="protem_secretarty"
							placeholder="Enter protem secretary name"
							required
						/>
					</div>
				</form>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-cancel" @click.prevent="hideModal">
					Cancel
				</button>
				<LoadingButton
					type="submit"
					form="accessCodeForm"
					class="btn btn-submit text-white"
				>
					Generate Access Code
				</LoadingButton>
			</div>
		</div>
	</Modal>
</template>

<script>
import Swal from "sweetalert2";
import Modal from "@/components/Modal.vue";
import Alert from "@/components/Alert.vue";
import { EventBus } from "@/utils/event_bus.js";
import LoadingButton from "@/components/LoadingButton.vue";

export default {
	components: {
		Modal,
		Alert,
		LoadingButton,
	},
	data() {
		return {
			form: {
				logoPreview: null,
				proposed_name: "",
				acronym: "",
				motto: "",
				protem_chairman: "",
				protem_secretarty: "",
				logo: null,
			},
		};
	},
	methods: {
		handleLogoUpload(event) {
			const file = event.target.files[0];
			if (file) {
				this.form.logo = file;
				const reader = new FileReader();
				reader.onload = (e) => {
					this.form.logoPreview = e.target.result;
				};
				reader.readAsDataURL(file);
			}
		},

		async handleSubmit() {
			let fd = new FormData();
			fd.append("proposed_name", this.form.proposed_name);
			fd.append("acronym", this.form.acronym);
			fd.append("protem_chairman", this.form.protem_chairman);
			fd.append("protem_secretarty", this.form.protem_secretarty);
			fd.append("motto", this.form.motto);
			// fd.append("logo", this.form.logo);

			this.$store
				.dispatch("parties/generateApplicationCode", fd)
				.then((resp) => {
					console.log(resp);

					if (resp.status_code === 201) {
						this.hideModal();
						Swal.fire({
							icon: "success",
							title: "Success",
							text: resp.status_message,
						}).then(() => {
							if (resp.data.id) {
								this.$router.push({
									name: "PartyDetails",
									params: { id: resp.data.id },
								});
							}
						});
					} else {
						Swal.fire({
							icon: "error",
							title: "Error",
							text: resp.response.data.errors.message,
						});
						this.isLoading = false;
					}
				});
		},

		resetForm() {
			this.form = {
				logoPreview: null,
				proposed_name: "",
				motto: "",
				acronym: "",
				protem_chairman: "",
				protem_secretarty: "",
				logo: null,
			};
		},

		showModal() {
			EventBus.$emit("toggle-modal", "show");
		},

		hideModal() {
			EventBus.$emit("toggle-modal", "hide");
		},
	},
};
</script>

<style>
h5 {
	color: #fff;
}
.form-control {
	padding-left: 5px !important;
}
.modal-header {
	background: linear-gradient(135deg, #29623c 0%, #29623c 100%);
	color: white;
}
.modal-content {
	border: none;
	border-radius: 10px;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}
.logo-container {
	text-align: center;
	margin: 20px 0;
}
.logo-preview {
	width: 100px;
	height: 100px;
	border-radius: 50%;
	background-color: #f8f9fa;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 auto;
	overflow: hidden;
	border: 2px dashed #ccc;
}
.logo-preview i {
	font-size: 40px;
	color: #6c757d;
}
.logo-preview img {
	max-width: 100%;
	max-height: 100%;
}
.form-group label {
	font-weight: 600;
	color: #495057;
}
.btn-submit {
	background: linear-gradient(135deg, #29623c 0%, #29623c 100%);
	border: none;
	font-weight: 600;
}
.btn-cancel {
	border: 1px solid #29623c;
	color: #29623c;
	font-weight: 600;
}
</style>
